import { requestFilterSetPermissions } from 'redux/redux-modules'
import { putResolve, select } from 'redux-saga/effects'

import type { ModalSections } from '../sections.types'
import { sectionModalsSelector } from '../selectors'

export function* addPublicPermissionAssignmentSaga() {
  const sectionModals: ModalSections = yield select(sectionModalsSelector)

  if (!sectionModals.permissions) {
    return []
  }

  yield putResolve(
    requestFilterSetPermissions.actions.makeRequest({
      payload: {
        permission: 'VIEW',
        request_filter_set_id: sectionModals.permissions.id,
        assignee_user_group_id: null,
        assignee_user_id: null,
      },
    }),
  )

  // yield delay(1000)

  // yield put(setSectionModal({ type: 'permissions', requestFilterSet: null }))
  // yield put(setSelectedSection(null))
  // yield put(setActiveFilterType('public'))

  return []
}
